import React from "react";

const ViewDoc = ({ data, ismodalopen, setHtmlModal }) => {
    if (!ismodalopen || !data || !data.json_data) return null;

    const json = data.json_data;

    const closeModal = () => setHtmlModal(false);

    const epworthRows = [
        { label: "Sitting and reading", name: "qanswer_6_17" },
        { label: "Watching TV", name: "qanswer_6_18" },
        { label: "Sitting inactive in a public place", name: "qanswer_6_19" },
        { label: "As a passenger in a car for an hour without a break", name: "qanswer_6_20" },
        { label: "Lying down to rest in the afternoon when circumstances permit", name: "qanswer_6_21" },
        { label: "Sitting and talking to someone", name: "qanswer_6_22" },
        { label: "Sitting quietly after lunch without alcohol", name: "qanswer_6_23" },
        { label: "In a car, while stopped for a few minutes in traffic or at a red light", name: "qanswer_6_24" },
    ];

    const comorbidConditions = [
        "Hypertension",
        "Stroke",
        "PLMD",
        "RBD",
        "Leg Jerking",
        "Diabetes",
        "Sleep talking",
        "Sleepwalking",
        "Neuromuscular Disorder",
        "COPD",
        "Epilepsy/Seizure",
        "CHF",
        "Coronary artery disease",
        "Bruxism (grinding teeth)",
        "Unspecified Insomnia",
    ];

 const renderYesNo = (value) => (
  <div className="flex space-x-4 mt-2">
    {["YES", "NO"].map((opt) => (
      <span
        key={opt}
        className={`px-4 py-2 rounded-full text-sm font-sans ${
          json[value]?.toLowerCase() === opt.toLowerCase()
            ? "bg-blue-600 text-white border border-blue-600"
            : "bg-white border-2 border-gray-300 text-black"
        }`}
      >
        {opt}
      </span>
    ))}
  </div>
);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto text-start">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-2xl font-bold">{json.form_name}</h2>
                    <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">&times;</button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="font-bold text-base">Patient Name</label>
                        <p className="mb-3">{json.patient_name}</p>
                    </div>
                    <div>
                        <label className="font-bold text-base">Date</label>
                        <p className="mb-3">{json.cdate}</p>
                    </div>
                    <div>
                        <label className="font-bold text-base">Provider Name</label>
                        <p className="mb-3">{json.provider_name}</p>
                    </div>
                    <div>
                        <label className="font-bold text-base">Date of Birth</label>
                        <p className="mb-3">{json.dob}</p>
                    </div>
                </div>

                <h3 className="font-bold text-xl mt-4">Vitals</h3>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                    {[
                        { label: "HT", value: json.ptheight },
                        { label: "WT", value: json.ptweight },
                        { label: "BMI", value: json.ptbmi },
                        { label: "BP", value: json.ptbp },
                        { label: "NC", value: json.ptnc },
                    ].map((item, idx) => (
                        <div key={idx}>
                            <label className="font-bold text-base">{item.label}</label>
                            <p className="mb-3">{item.value}</p>
                        </div>
                    ))}
                </div>

                <h3 className="font-bold text-xl mt-4">Insomnia</h3>
                {[
                    { question: "Are you currently using a CPAP machine?", key: "qanswer_6_2" },
                    { question: "Do you have trouble falling asleep?", key: "qanswer_6_3" },
                    { question: "Do you have trouble falling asleep?", key: "qanswer_6_4" },
                ].map((q, idx) => (
                    <div className="mb-4" key={idx}>
                        <label className="font-bold text-base">{q.question}</label>
                        {renderYesNo(q.key)}
                    </div>
                ))}

                <h3 className="font-bold text-xl mt-4">OSA Evaluation - Snoring</h3>
                {[
                    { question: "Do you snore or have been told you snore?", key: "qanswer_6_5" },
                    { question: "Gasping/Choking arousals?", key: "qanswer_6_6" },
                    { question: "Have you gained or lost 20% or more of your body weight?", key: "qanswer_6_7" },
                    { question: "Urge to move legs when trying to sleep?", key: "qanswer_6_8" },
                    { question: "Tingling or crawly feeling in the legs?", key: "qanswer_6_9" },
                    { question: "Urge to move is worse when seated/lying down?", key: "qanswer_6_10" },
                ].map((q, idx) => (
                    <div className="mb-4" key={idx}>
                        <label className="font-bold text-base">{q.question}</label>
                        {renderYesNo(q.key)}
                    </div>
                ))}

                <h3 className="font-bold text-xl mt-4">Daytime Sleepiness Scale</h3>
                {[
                    { question: "Feeling sleepy?", key: "qanswer_6_11" },
                    { question: "Tired no energy?", key: "qanswer_6_12" },
                    { question: "Difficulty concentrating?", key: "qanswer_6_13" },
                    { question: "Napping on purpose?", key: "qanswer_6_14" },
                    { question: "Sleepy while driving?", key: "qanswer_6_15" },
                    { question: "Dozing off at work?", key: "qanswer_6_16" },
                ].map((q, idx) => (
                    <div className="mb-4" key={idx}>
                        <label className="font-bold text-base">{q.question}</label>
                        {renderYesNo(q.key)}
                    </div>
                ))}

                <h3 className="font-bold text-xl mt-4">Epworth Sleepiness Scale</h3>
                <p className="font-semibold">Do you feel very sleepy or fall asleep during these situations?</p>
                <h4 className="font-semibold">Situation chance of dozing (0-3)</h4>
                <table className="w-full border-collapse">
                    <thead>
                        <tr>
                            <th className="text-left py-2"></th>
                            <th className="text-center">0</th>
                            <th className="text-center">1</th>
                            <th className="text-center">2</th>
                            <th className="text-center">3</th>
                        </tr>
                    </thead>
                    <tbody>
                        {epworthRows.map((item, idx) => (
                            <tr key={idx}>
                                <th className="text-left py-2">{item.label}</th>
                                {[0, 1, 2, 3].map((val) => (
                                    <td key={val} className="text-center">
                                        <span
                                            className={`px-4 py-2 rounded-full text-sm font-sans ${
                                                Number(json[item.name]) === val
                                                    ? "bg-blue-600 text-white border border-blue-600"
                                                    : "bg-white border-2 border-gray-300 text-black"
                                            }`}
                                        >
                                            {val}
                                        </span>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>

                <h3 className="font-bold text-xl mt-4">Related Comorbid Condition</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                    {comorbidConditions.map((cond, idx) => (
                        <div key={idx} className="flex items-center m-2">
                            <input
                                type="checkbox"
                                name="qanswer_6_25"
                                value={cond}
                 checked={Array.isArray(json.qanswer_6_25) && json.qanswer_6_25.includes(cond)}
                                readOnly
                                className="mr-2 cursor-not-allowed"
                            />
                            <label>{cond}</label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ViewDoc;
